import { map, switchMap } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Command, CommandBase } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { MessageService } from '../../../core/service/message.service';
import { DwellingService } from '../data/dwelling.service';
import { rentalObjectCommand } from '../../command/rental-object.command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { BrokerInformationFormComponent } from '../../component/broker-information-form/broker-information-form.component';
import { RentalObject } from '../../model/rental-object';

@Injectable()
export class PrintBrokerInformationCommandHandler implements ICommandHandler {
  constructor(
    private _actionService: ActionWindowService,
    private _injector: Injector,
    private _service: DwellingService,
    private _messageService: MessageService
  ) {}

  canExecute(command: Command): boolean {
    return command.id === rentalObjectCommand.printBrokerInformation && command.context;
  }

  execute(command: CommandBase): Observable<boolean | void> {
    if (command instanceof Command) {
      const rentalObject = this.getRentalObject(command.context);
      if (!rentalObject) {
        this._messageService.showMessage('RENTAL_OBJECT.BROKER_INFORMATION_MISSING_RENTAL_OBJECT_MESSAGE');
        return of(false);
      }

      return rentalObject.pipe(
        switchMap(rentalObject =>
          this._actionService.open(BrokerInformationFormComponent, this._injector, null, rentalObject, false)
        ),
        map(res => !!res)
      );
    }
  }

  private getRentalObject(context: any): Observable<RentalObject> | null {
    if (context instanceof RentalObject) {
      return of(context);
    }

    const rentalObjectId =
      context.rentalObjectId ??
      context.rentalObjects?.find(item => item.linkOrder === 1)?.rentalObjectId ??
      context.rentalObjects?.[0]?.rentalObjectId;

    return rentalObjectId ? this._service.get(rentalObjectId) : null;
  }
}
